import { trackFaireDirectMarketplaceIncentiveBannerViewDetailsClick } from "@faire/web-api/events/faireDirect/click/marketplaceIncentiveBannerViewDetails";
import { useCallback } from "react";

import { useOpenMarketplaceIncentiveTermsModal } from "@faire/retailer/components/App/AppModals/utils";
import { useFaireDirectMarketplaceIncentive } from "@faire/retailer/hooks/FaireDirect/useFaireDirectMarketplaceIncentive/useFaireDirectMarketplaceIncentive";
import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

export const useFaireDirectMarketplaceIncentiveBannerViewDetailsHandleClick =
  () => {
    const { openMarketplaceIncentiveTermsModal } =
      useOpenMarketplaceIncentiveTermsModal();

    const { retailerToken } = useRetailerStore(["retailerToken"]);
    const { isFaireDirectEvergreenIncentive } =
      useFaireDirectMarketplaceIncentive();

    const incentiveType = isFaireDirectEvergreenIncentive
      ? "evergreen"
      : "marketplace";

    return useCallback(() => {
      trackFaireDirectMarketplaceIncentiveBannerViewDetailsClick(
        retailerToken ?? "",
        incentiveType
      );
      openMarketplaceIncentiveTermsModal();
    }, [incentiveType, openMarketplaceIncentiveTermsModal, retailerToken]);
  };
